// removed by extract-text-webpack-plugin
module.exports = {"ToggleTypeBox":"ToggleTypesBox_ToggleTypeBox__1Q7t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Map/ToggleTypes/ToggleTypesBox.scss
// module id = 524
// module chunks = 0